<script setup lang="ts">

</script>

<template>
    <div class="mt-10 mb-14 text-center">
        <h1 class="text-4xl">Payment Successful</h1>

        <a href="/api-subscriptions" class="my-[4rem] block text-blue-500">See subscriptions →</a>
    </div>
</template>
